export const FOR_ALL_SHOPS_IN_COMPANY = 'FOR_ALL_SHOPS_IN_COMPANY'

export const mapLicenseShopIDForAPI = (shopID: string): string | undefined => {
  if (shopID === FOR_ALL_SHOPS_IN_COMPANY) {
    return undefined
  }
  return shopID
}
